export enum EventStatus {
  EVENT_STATUS_INVALID = 'EVENT_STATUS_INVALID',
  /** EVENT_STATUS_PENDING - Created but not confirmed */
  EVENT_STATUS_PENDING = 'EVENT_STATUS_PENDING',
  /** EVENT_STATUS_UPCOMING - Pass approved and ready to be scanned */
  EVENT_STATUS_UPCOMING = 'EVENT_STATUS_UPCOMING',
  /** When visitorValidation is true upcoming can only go to validated */
  EVENT_STATUS_VALIDATED = 'EVENT_STATUS_VALIDATED',
  EVENT_STATUS_CHECKED_IN = 'EVENT_STATUS_CHECKED_IN',
  EVENT_STATUS_CHECKED_OUT = 'EVENT_STATUS_CHECKED_OUT',
  /** EVENT_STATUS_NO_SHOW - Pass was not used during time range, or manually marked */
  EVENT_STATUS_NO_SHOW = 'EVENT_STATUS_NO_SHOW',
  EVENT_STATUS_CANCELLED = 'EVENT_STATUS_CANCELLED',
  RECURRENCE_EVENT_STATUS_CANCELLED = 'RECURRENCE_EVENT_STATUS_CANCELLED',
  /** EVENT_STATUS_WITHDRAWN - Pass was checked in but cancelled within the valid timeframe */
  EVENT_STATUS_WITHDRAWN = 'EVENT_STATUS_WITHDRAWN',
  EVENT_STATUS_DELETED = 'EVENT_STATUS_DELETED',
  /** EVENT_STATUS_ARCHIVED - Pass belonged to a recurrence that has been updated */
  EVENT_STATUS_ARCHIVED = 'EVENT_STATUS_ARCHIVED',
  /** EVENT_STATUS_EXPIRED - Pass was checked in but not checked out until end time elapsed */
  EVENT_STATUS_EXPIRED = 'EVENT_STATUS_EXPIRED',
  /** EVENT_STATUS_REJECTED - Pass was rejected */
  EVENT_STATUS_REJECTED = 'EVENT_STATUS_REJECTED',
  /** EVENT_STATUS_FAILED - Pass update or integration flow failed */
  EVENT_STATUS_FAILED = 'EVENT_STATUS_FAILED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum RecurrenceEventStatus {
  RECURRENCE_EVENT_STATUS_INVALID = 'RECURRENCE_EVENT_STATUS_INVALID',
  RECURRENCE_EVENT_STATUS_APPROVED = 'RECURRENCE_EVENT_STATUS_APPROVED',
  RECURRENCE_EVENT_STATUS_CANCELLED = 'RECURRENCE_EVENT_STATUS_CANCELLED',
}

